import {
  NOTIFICATION_SUCCESS,
  NOTIFICATION_WARNING,
  NOTIFICATION_ERROR,
  NOTIFICATION_RESET,
  NOTIFICATION_CLICKED,
} from './types';

/**
 * Create notification error
 * @param {string} message
 * @returns {{type: *, payload: {error: *}}}
 */
export function error(message) {
  return { type: NOTIFICATION_ERROR, payload: { message } };
}

/**
 * Create notification success action
 * @param {string} message
 * @returns {{type, payload: {message: *}}}
 */
export function success(message) {
  return { type: NOTIFICATION_SUCCESS, payload: { message } };
}

/**
 * Create notification warning action
 * @param {string} message
 * @returns {{type, payload: {message: *}}}
 */
export function warning(message) {
  return { type: NOTIFICATION_WARNING, payload: { message } };
}

/**
 * Clear all notification
 * @returns {{type: *}}
 */
export function reset() {
  return { type: NOTIFICATION_RESET };
}

export function onClickNotif(notificationClicked) {
  return { type: NOTIFICATION_CLICKED, payload: { notificationClicked } };
}
